import React, { useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Accordion, Alert } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaUsers, FaLaptopCode, FaChartBar, FaClock, FaMapMarkerAlt, FaRupeeSign  } from 'react-icons/fa';
import './Careers.css';

const Careers = () => {
  const [showApplication, setShowApplication] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const formRef = useRef(null);
  
  // Animation variants
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  // Job listings data
  const jobs = [
    {
      id: 1,
      title: 'Frontend Developer',
      department: 'Engineering',
      location: 'Indore, M.P. (Remote Option)',
      type: 'Full-time || Part-time',
      salary: '10,000 - 13,000',
      description: 'We\'re looking for a Senior Frontend Developer to join our team and help build exceptional user experiences for our clients.',
      responsibilities: [
        'Develop responsive and interactive web applications using React, HTML, CSS, and JavaScript',
        'Collaborate with designers, back-end developers, and product managers',
        'Optimize applications for maximum speed and scalability',
        'Implement UI/UX designs and wireframes',
        'Write clean, efficient, and maintainable code'
      ],
      requirements: [
        '4+ years of experience with frontend development',
        'Proficiency in React and modern JavaScript (ES6+)',
        'Strong understanding of responsive design principles',
        'Experience with state management (Redux, Context API)',
        'Knowledge of modern UI/UX principles and practices',
        'Bachelor\'s degree in Computer Science or equivalent experience'
      ]
    },
    {
      id: 2,
      title: 'UX/UI Designer',
      department: 'Design',
      location: 'Indore, M.P. (Remote Option)',
      type: 'Full-time',
      salary: '9,000 - 10,000',
      description: 'We are seeking a talented UX/UI Designer to create beautiful, intuitive interfaces for our web and mobile applications.',
      responsibilities: [
        'Create user-centered designs by understanding business requirements and user feedback',
        'Develop and conceptualize a comprehensive UI/UX design strategy',
        'Create wireframes, prototypes, and user flows',
        'Collaborate with product and engineering teams',
        'Conduct user research and testing'
      ],
      requirements: [
        '3+ years of UX/UI design experience',
        'Strong portfolio demonstrating UI/UX projects',
        'Proficiency in design tools (Figma, Adobe XD, Sketch)',
        'Understanding of interaction design and information architecture',
        'Knowledge of web/mobile design principles and best practices',
        'Bachelor\'s degree in Design, HCI, or equivalent experience'
      ]
    },
    {
      id: 3,
      title: 'Digital Marketing Specialist',
      department: 'Marketing',
      location: 'Indore, M.P. (Remote Option)',
      type: 'Full-time',
      salary: '7,000 - 9,000',
      description: 'We\'re seeking a Digital Marketing Specialist to help grow our online presence and support our clients\' marketing initiatives.',
      responsibilities: [
        'Develop and implement digital marketing strategies',
        'Manage social media accounts and create engaging content',
        'Analyze SEO/SEM metrics and implement improvements',
        'Coordinate email marketing campaigns',
        'Track and report on marketing performance metrics'
      ],
      requirements: [
        '2+ years of experience in digital marketing',
        'Knowledge of SEO/SEM and web analytics',
        'Experience with social media management and content creation',
        'Familiarity with email marketing platforms',
        'Strong analytical and communication skills',
        'Bachelor\'s degree in Marketing or related field'
      ]
    },
    {
      id: 4,
      title: 'MERN stack Intern',
      department: 'Engernerring',
      location: 'Indore, M.P. (Remote Option)',
      type: 'Full-time',
      salary: '7,000 - 9,000',
      description: 'We\'re seeking a MERN stack Intern to help our expert and support our clients\' issues.',
      responsibilities: [
        'As a support assistent of our expert',
        'Collaborate with designers and front-end developers',
        'Resolve the client issues regarding design'
      ],
      requirements: [
        'Oppening for freshers',
        'Bachelor\'s in Technology',
        'Strong communication skills and have a team work',
        'Familiarity with email marketing platforms',
      ]
    }
  ];

  // Benefits data
  const benefits = [
    {
      id: 1,
      icon: <FaRupeeSign  />,
      title: 'Competitive Salary',
      description: 'We offer competitive compensation packages that recognize your skills and experience.'
    },
    {
      id: 2,
      icon: <FaUsers />,
      title: 'Health Benefits',
      description: 'Comprehensive health, dental, and vision insurance for you and your dependents.'
    },
    {
      id: 3,
      icon: <FaClock />,
      title: 'Flexible Work Hours',
      description: 'We understand the importance of work-life balance with flexible scheduling options.'
    },
    {
      id: 4,
      icon: <FaLaptopCode />,
      title: 'Remote Work Options',
      description: 'Work from home or our office with our hybrid work model.'
    },
    {
      id: 5,
      icon: <FaChartBar />,
      title: 'Professional Growth',
      description: 'Continuous learning opportunities, mentorship, and career advancement.'
    },
    {
      id: 6,
      icon: <FaMapMarkerAlt />,
      title: 'Team Events',
      description: 'Regular team activities and annual retreats to foster collaboration and fun.'
    }
  ];

  // Intersection observer hooks
  const [headerRef, headerInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [jobsRef, jobsInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [benefitsRef, benefitsInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  
  const handleApplyNow = (job) => {
    setSelectedJob(job);
    setShowApplication(true);
    setTimeout(() => {
      window.scrollTo({
        top: formRef.current.offsetTop - 100,
        behavior: 'smooth'
      });
    }, 100);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    
      // Create a FormData object to capture form data
  const formData = new FormData(e.target);

  // Convert FormData to JSON object
  const data = Object.fromEntries(formData.entries());

  console.log('Form Data:', data);

  // Send data to Google Sheets using fetch
  try {
    const res = await fetch('AKfycbyhEWLM5bX5x0wbacmaE3ZLB6hM2GZ7eRBrNbpDvI5v3bk786Uj8dclg81oXcg1k8zipw', {
      method: 'POST',
      mode: 'no-cors', // Use 'no-cors' for Google Sheets
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        fullName: data['Full Name'],
        email: data['Email Address'],
        phone: data['Phone Number'],
        location: data['Current Location'],
        linkedin: data['LinkedIn Profile'],
        portfolio: data['Portfolio/GitHub'],
        resume: data['Upload Resume'] ? data['Upload Resume'].name : '',
        coverLetter: data['Cover Letter']
      })
    });

    if (res.ok) {
      alert('Application submitted successfully!');
    } else {
      alert('Failed to submit application.');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('An error occurred. Please try again.');
  }
  };

  return (
    <div className="careers-page">
      {/* Page Header */}
      <section className="careers-header" ref={headerRef}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} md={10}>
              <motion.div
                initial="hidden"
                animate={headerInView ? "visible" : "hidden"}
                variants={fadeIn}
              >
                <h1 className="page-title">Join Our Team</h1>
                <p className="lead">
                  We're looking for talented individuals to help us build amazing digital experiences. Explore our opportunities and find your next role with us.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Current Openings Section */}
      <section className="jobs-section section-padding" ref={jobsRef}>
        <Container>
          <Row className="mb-5">
            <Col lg={12} className="text-center">
              <motion.div
                initial="hidden"
                animate={jobsInView ? "visible" : "hidden"}
                variants={fadeIn}
              >
                <h2 className="section-title mx-auto">Current Openings</h2>
                <p className="section-description">Explore our open positions and find the perfect fit for your skills and career goals.</p>
              </motion.div>
            </Col>
          </Row>
          <motion.div
            initial="hidden"
            animate={jobsInView ? "visible" : "hidden"}
            variants={staggerContainer}
          >
            <Row>
              {jobs.map((job) => (
                <Col lg={4} md={6} className="mb-4" key={job.id}>
                  <motion.div variants={fadeIn}>
                    <Card className="job-card card-hover h-100">
                      <Card.Body className="p-4">
                        <div className="job-department">{job.department}</div>
                        <Card.Title className="job-title my-2">{job.title}</Card.Title>
                        <Card.Text className="job-description">{job.description}</Card.Text>
                        <div className="job-details mb-3">
                          <div className="job-detail">
                            <FaMapMarkerAlt className="job-icon" />
                            <span>{job.location}</span>
                          </div>
                          <div className="job-detail">
                            <FaClock className="job-icon" />
                            <span>{job.type}</span>
                          </div>
                          <div className="job-detail">
                            <FaRupeeSign  className="job-icon" />
                            <span>{job.salary}</span>
                          </div>
                        </div>
                        <Button 
                          variant="primary" 
                          className="btn-gradient w-100"
                          onClick={() => handleApplyNow(job)}
                        >
                          Apply Now
                        </Button>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section section-padding" ref={benefitsRef}>
        <Container>
          <Row className="mb-5">
            <Col lg={12} className="text-center">
              <motion.div
                initial="hidden"
                animate={benefitsInView ? "visible" : "hidden"}
                variants={fadeIn}
              >
                <h2 className="section-title mx-auto">Why Work With Us</h2>
                <p className="section-description">We offer a range of benefits designed to support your professional and personal well-being.</p>
              </motion.div>
            </Col>
          </Row>
          <motion.div
            initial="hidden"
            animate={benefitsInView ? "visible" : "hidden"}
            variants={staggerContainer}
          >
            <Row>
              {benefits.map((benefit) => (
                <Col lg={4} md={6} className="mb-4" key={benefit.id}>
                  <motion.div variants={fadeIn}>
                    <Card className="benefit-card card-hover h-100">
                      <Card.Body className="p-4">
                        <div className="benefit-icon">
                          {benefit.icon}
                        </div>
                        <Card.Title className="benefit-title my-3">{benefit.title}</Card.Title>
                        <Card.Text>{benefit.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Application Form Section */}
      {showApplication && (
        <section className="application-section section-padding" ref={formRef}>
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={12}>
                <Card className="application-card">
                  <Card.Body className="p-4 p-lg-5">
                    <h3 className="mb-4">Apply for: {selectedJob.title}</h3>
                    
                    <Accordion className="mb-4">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>Job Description</Accordion.Header>
                        <Accordion.Body>
                          <p>{selectedJob.description}</p>
                          <h5>Responsibilities:</h5>
                          <ul>
                            {selectedJob.responsibilities.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                          <h5>Requirements:</h5>
                          <ul>
                            {selectedJob.requirements.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    
                    {formSubmitted ? (
                      <Alert variant="success">
                        <Alert.Heading>Application Submitted!</Alert.Heading>
                        <p>
                          Thank you for your interest in joining our team. We've received your application and will review it shortly. If your qualifications match our needs, we'll contact you to schedule an interview.
                        </p>
                      </Alert>
                    ) : (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Full Name</Form.Label>
                              <Form.Control type="text" required />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Email Address</Form.Label>
                              <Form.Control type="email" required />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Phone Number</Form.Label>
                              <Form.Control type="tel" required />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Current Location</Form.Label>
                              <Form.Control type="text" required />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Form.Group className="mb-3">
                          <Form.Label>LinkedIn Profile (Optional)</Form.Label>
                          <Form.Control type="url" placeholder="https://linkedin.com/in/your-profile" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Portfolio/GitHub (Optional)</Form.Label>
                          <Form.Control type="url" placeholder="https://" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Upload Resume (PDF)</Form.Label>
                          <Form.Control type="file" accept=".pdf" required />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Cover Letter</Form.Label>
                          <Form.Control as="textarea" rows={5} required />
                        </Form.Group>
                        <Form.Group className="mb-4">
                          <Form.Check 
                            type="checkbox" 
                            label="I agree to the processing of my personal data according to your privacy policy." 
                            required 
                          />
                        </Form.Group>
                        <Button type="submit" className="btn-gradient">
                          Submit Application
                        </Button>
                      </Form>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      {/* CTA Section */}
      <section className="careers-cta-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} md={12}>
              <div className="cta-content">
                <h2>Don't See the Right Role?</h2>
                <p>We're always looking for talented individuals to join our team. Send us your resume and let us know how you can contribute.</p>
                <Button variant="light" className="btn-lg" href="mailto:careers@websolutions.com">
                  Contact Our Hiring Team
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Careers; 